<template>
  <div class="header">
    <div class="header-inner">
      <div class="menu-left">
        <div class="hamburger-icon" @click="toggleMenu">
          <Icon icon="hamburger" color="white" />
        </div>
        <router-link :to="{ name: homeRoute }">
          <img :src="require('@/assets/nexcess-logo-icon.svg')" class="mobile-icon" />
        </router-link>
      </div>
      <div class="header-menu-options">
        <div class="header-menu-icons"></div>
        <DropDown :items="userMenuItems" v-if="user">
          <div class="header-menu-user-options" tabindex="10">
            <div class="avatar-circle">
              <div class="avatar-initials">{{ userInitials }}</div>
            </div>
            <div class="greeting">
              <div class="name">User Menu</div>
              <Icon icon="down" :size="9" />
            </div>
          </div>
        </DropDown>
      </div>
    </div>

    <div class="mobile-menu-slider left-nav-mobile" :class="{ open: menuIsOpen }">
      <div class="close-x" @click="closeMenu">
        <Icon icon="close" :size="14" />
      </div>
      <!-- <div class="test-open-right" @click="toggleSubMenu">Toggle the right menu</div> -->
      <div class="mobile-client-info" v-if="client">
        <div class="client-info">
          {{ $t("global.managed-by") }}<br />
          {{ client.name }}
        </div>
        <div class="account-info">
          <div class="account-id">{{ $t("global.account-id") }}: {{ client.id }}</div>
          <div class="account-pin">
            {{ $t("global.pin") }}: {{ pin }}
            <div class="pinToggle" @click="toggleShowPin">
              <Icon class="iconToggle" :icon="showPin ? 'hide' : 'view'" :size="20" />
            </div>
          </div>
        </div>
      </div>
      <div class="items-container">
        <div v-if="!loading" class="left-nav-items">
          <div class="left-nav-item left-nav-back" v-if="back" @click="back.action">
            <Icon class="nav-icon" icon="angle-left" :size="14" />
            <div class="nav-text">
              {{ back.name ? `${back.name}` : $t("global.go-back") }}
            </div>
          </div>
          <!--          <div class="left-nav-title" v-if="menuTitle">-->
          <!--            {{ menuTitle }}-->
          <!--          </div>-->
          <div
            class="left-nav-item"
            v-for="(item, i) in menuItems"
            :key="i"
            @click="executeAction(item.action)"
            :class="{ active: routeMatches(item.routeName) }"
            :data-test="`mobile-nav-left-${formatDataTest(item.name)}`"
          >
            <Icon class="nav-icon" :icon="item.icon" :size="14" />
            <div class="nav-text">
              {{ item.name }}
              <Pill v-if="item.admin" class="ml-1" :content="$t('global.admin')" variant="dark" />
            </div>
          </div>
        </div>

        <div v-if="loading" class="left-nav-items">
          <div class="loading-block-container">
            <div class="loading-block nav-loading-block-left"></div>
            <div class="loading-block nav-loading-block-right"></div>
          </div>
          <div class="loading-block-container">
            <div class="loading-block nav-loading-block-left"></div>
            <div class="loading-block nav-loading-block-right"></div>
          </div>
          <div class="loading-block-container">
            <div class="loading-block nav-loading-block-left"></div>
            <div class="loading-block nav-loading-block-right"></div>
          </div>
          <div class="loading-block-container">
            <div class="loading-block nav-loading-block-left"></div>
            <div class="loading-block nav-loading-block-right"></div>
          </div>
        </div>
      </div>
      <div class="left-nav-footer">
        <div class="left-nav-footer-help">
          {{ $t("global.footer-help") }}
        </div>
        <div class="left-nav-footer-icons">
          <div
            v-for="(helper, h) in helpItems"
            :key="h"
            class="left-nav-icon-container"
            @click="helper.action"
          >
            <Icon :icon="helper.icon" />
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-menu-sub-slider" :class="{ open: subMenuIsOpen }">Here is a submenu</div>
    <transition name="fade">
      <div class="mobile-menu-underlay" v-if="menuIsOpen" @click="closeMenu"></div>
    </transition>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import constants from "@/utils/constants";
import DropDown from "@/components/display/DropDown";
import Icon from "@/components/display/icon/Icon";
import NavLink from "@/classes/NavLink";
import Pill from "@/components/display/Pill";

export default {
  name: "NavTopMobile",
  components: {
    DropDown,
    Icon,
    Pill,
  },
  props: {
    user: Object,
    client: Object,
    userMenuItems: {
      validator: (value) => {
        if (!Array.isArray(value)) {
          return false;
        }

        return value.filter((item) => !(item instanceof NavLink)).length === 0;
      },
    },
    homeRoute: {
      type: String,
      default: constants.HOME_ROUTE,
    },
    back: NavLink,
    menuTitle: String,
    menuItems: Array,
    loading: Boolean,
    helpItems: {
      validator: (value) => {
        if (!Array.isArray(value)) {
          return false;
        }

        return value.filter((item) => !item.icon || !item.action).length === 0;
      },
    },
  },
  setup(props, { emit, root }) {
    const menuIsOpen = ref(false);
    const subMenuIsOpen = ref(false);

    const toggleMenu = () => {
      menuIsOpen.value = !menuIsOpen.value;
      if (!menuIsOpen.value && subMenuIsOpen.value) {
        subMenuIsOpen.value = false;
      }
      emit("value", menuIsOpen.value);
    };

    const closeMenu = () => {
      menuIsOpen.value = false;
      subMenuIsOpen.value = false;
    };

    const toggleSubMenu = () => {
      subMenuIsOpen.value = !subMenuIsOpen.value;
    };

    const closeSubMenu = () => {
      subMenuIsOpen.value = false;
    };

    const executeAction = (action) => {
      action();
      closeMenu();
    };

    const userInitials = computed(() => {
      if (props.user) {
        if (props.user.firstName && props.user.lastName) {
          return props.user.firstName.slice(0, 1) + props.user.lastName.slice(0, 1);
        }
        return props.user.email.slice(0, 1);
      }
      return null;
    });

    const userGreeting = computed(() => {
      if (props.user) {
        if (props.user.firstName) {
          return `${props.user.firstName}`;
        }
        return `${props.user.email}`;
      }
      return null;
    });

    // PIN functionality
    const showPin = ref(false);
    const pin = computed(() => {
      if (showPin.value) {
        return props.client.pin;
      }
      return "• • • • • •";
    });

    const toggleShowPin = () => {
      showPin.value = !showPin.value;
    };

    const formatDataTest = (input) => {
      return input.toLowerCase().replace(/(,|_| |;)/g, "-");
    };

    const routeMatches = (routeName) => {
      const matchedRoutes = [...root.$route.matched];
      const match = matchedRoutes.reverse().find((route) => routeName === route?.name);
      return !!match;
    };

    return {
      userInitials,
      userGreeting,
      showPin,
      pin,
      toggleShowPin,
      formatDataTest,
      toggleMenu,
      menuIsOpen,
      closeMenu,
      subMenuIsOpen,
      toggleSubMenu,
      closeSubMenu,
      routeMatches,
      executeAction,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
$menuwidth: 230px;
$nav-item-height-mobile: 45px;

.header {
  height: $header-height;
  font-size: 0.875rem;
  z-index: 900;

  .header-inner {
    padding: 0 0 0 $grid-gutter-width;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .menu-left {
      display: flex;
      align-items: center;

      .hamburger-icon {
        cursor: pointer;
      }
      .mobile-icon {
        margin-left: 2rem;
        cursor: pointer;
      }
    }
  }

  .header-client-container {
    font-size: 0.75rem;
  }

  .left-nav-mobile {
    // width: 215px;
    display: flex;
    flex-direction: column;
    height: 100%;
    // justify-content: space-between;

    // .logo {
    //   margin-bottom: 3rem;

    //   &.with-back {
    //     margin-bottom: 1rem;
    //   }
    // }

    .mobile-client-info {
      color: white;
      font-size: 0.75rem;
      padding: 0 1.5rem 1rem;

      .client-info {
        margin-bottom: 1rem;
      }

      .account-info {
        .account-id {
          margin-bottom: 1rem;
        }
        .account-pin {
          display: flex;
          .pinToggle {
            margin-left: 1rem;
          }
        }
      }
    }

    .items-container {
      flex-grow: 1;
      overflow-x: hidden;
      overflow-y: auto;
      // scroll-snap-type: y mandatory;
      justify-content: space-between;
      display: flex;
      flex-direction: column;

      /* Works on Chrome/Edge/Safari */
      // &::-webkit-scrollbar {
      //   width: 12px;
      // }
      // &::-webkit-scrollbar-thumb {
      //   border-radius: 5px;
      //   border-width: 2px;
      //   border-style: solid;
      // }

      /* Works on Firefox */
      // scrollbar-width: thin;

      .left-nav-title {
        font-size: 0.75rem;
        text-transform: uppercase;
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-bottom: 1rem;
        height: $nav-item-height-mobile;
        font-weight: 600;
        padding-left: 24px;
      }

      .left-nav-item {
        font-size: 0.75rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: $nav-item-height-mobile;
        cursor: pointer;
        padding-left: $nav-padding-side;
        scroll-snap-align: end;
        text-decoration: none;

        &:hover {
          text-decoration: none;
        }

        .nav-icon {
          margin-right: 1rem;
        }

        .nav-text {
          font-weight: 600;
        }
      }

      .left-nav-back {
        font-size: 0.75rem;

        .nav-text {
          text-transform: uppercase;
        }
      }
    }

    .left-nav-footer {
      height: 100px;
      flex-grow: 0;
      font-size: 0.875rem;
      padding: 20px $nav-padding-side;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: center;
      .left-nav-footer-help {
        margin-bottom: 0.5rem;
      }
      .left-nav-footer-icons {
        display: flex;
        align-content: center;
        justify-content: space-around;
      }
    }
  }

  .header-menu-options {
    display: flex;

    .header-menu-icons {
      display: flex;
      align-items: center;
      margin-right: 1rem;

      .header-menu-icon {
        svg {
          padding: 5px;
        }
        &.active {
          border-radius: $border-radius;
        }
        &:hover {
          border-radius: $border-radius;
        }
      }
    }

    .header-menu-user-options {
      display: flex;
      flex-direction: row;
      position: relative;
      height: 100%;
      align-items: center;
      cursor: pointer;
      padding: 9px;

      &:focus {
        outline: none;
      }

      .header-menu-list {
        position: absolute;
        display: none;
      }

      .avatar-circle {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-width: 1px;
        border-style: solid;
        border-radius: 1rem;
        margin-right: 12px;
        .avatar-initials {
          text-transform: uppercase;
        }
      }

      .greeting {
        display: flex;
        flex-direction: row;
        align-items: center;

        .name {
          margin-right: 6px;
        }
      }

      &:hover,
      &:focus,
      &.forceshow {
        .header-menu-list {
          display: block;
          border-radius: $border-radius;
          width: 200px;
          top: 100%;
          right: 0;
          padding: 12px 0;
          z-index: 100;

          .menu-list-item {
            padding: 7px 14px;
            font-size: 0.875rem;
            text-decoration: none;
            width: 100%;
            display: block;

            &:hover {
              text-decoration: none;
            }
          }
        }
      }
    }
  }

  .mobile-menu-slider {
    position: fixed;
    left: 0;
    transform: translateX(-1.25 * $menuwidth);
    top: 0;
    height: 100%;
    z-index: 1000;
    transition: transform 0.5s ease;
    width: $menuwidth;
    display: flex;
    flex-direction: column;
    // background-color: $epsilon;
    box-shadow: 0 0 5px 0;

    &.open {
      transform: translateX(0);
    }

    .close-x {
      cursor: pointer;
      padding: 1.5rem;
    }
  }

  .mobile-menu-sub-slider {
    transform: translateX(-1.25 * $menuwidth);
    width: calc(100% - #{$menuwidth});
    max-width: $menuwidth;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    // background-color: blue;
    z-index: 975;
    transition: transform 0.5s ease;
    box-shadow: 0 0 5px 0;

    &.open {
      transform: translateX($menuwidth);
    }
  }

  .mobile-menu-underlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: black;
    z-index: 950;
    opacity: 0.5;
    transition: transform 0.25s ease;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
